import script from "./_form.vue?vue&type=script&lang=js"
export * from "./_form.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/assets/_form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68dcdb00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68dcdb00', __exports__)) {
    console.log('reload')
    api.reload('68dcdb00', __exports__)
  }
  
}


export default __exports__